export const cardHoldersEn = {};

export const cardHoldersFr = {};
